import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosApi } from "../../helpers/AxiosApi";
import initialStates from "./state";

// Companies List
export const companiesList = createAsyncThunk(
  "companiesList",
  async (
    { search, status, sort_by, pageLimit, sort_direction, pageCount },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `companies?search=${search}&sort_by=${sort_by}&sort_direction=${sort_direction}&status=${status}&page=${pageCount}&limit=${pageLimit}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Companies List bt id
export const getCompanies = createAsyncThunk(
  "getCompanies",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`companies/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Company
export const createCompany = createAsyncThunk(
  "createCompany",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`companies`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// update Company
export const updateCompany = createAsyncThunk(
  "updateCompany",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`companies/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete Director / Shareholder
export const DeleteCompany = createAsyncThunk(
  "DeleteCompany",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`companies/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Outlet List
export const getOutlet = createAsyncThunk(
  "getOutlet",
  async (
    {
      pageLimit,
      search,
      company_id,
      sort_by,
      sort_direction,
      status,
      outlet,
      manager,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `outlets?limit=${pageLimit}&search=${search}&sort_by=${sort_by}&sort_direction=${sort_direction}&company_id=${company_id}&status=${status}&outlet=${outlet}&manager=${manager}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Outlet
export const createOutlet = createAsyncThunk(
  "createOutlet",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`outlets`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Outlet
export const createEquipment = createAsyncThunk(
  "createEquipment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`company-equipment`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Equipment List
export const getEquipment = createAsyncThunk(
  "getEquipment",
  async (
    {
      search,
      sort_by,
      pageLimit,
      sort_direction,
      pageCount,
      equipment,
      outlet,
      company_id,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `company-equipment-list?search=${search}&sort_by=${sort_by}&sort_direction=${sort_direction}&page=${pageCount}&limit=${pageLimit}&equipment=${equipment}&outlet=${outlet}&company_id=${company_id}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// getAllTechnicianList
export const getAllTechnicianList = createAsyncThunk(
  "getAllTechnicianList",
  async ({ limit, search }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `technicians?limit=${limit}&search=${search}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Technician
export const createTechnician = createAsyncThunk(
  "createTechnician",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`company-technicians`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// getSalesPersonList
export const getSalesPersonList = createAsyncThunk(
  "getSalesPersonList",
  async ({ limit, search }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(
        `sales-person-list?limit=${limit}&search=${search}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Technician
export const createSalesPerson = createAsyncThunk(
  "createSalesPerson",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`company-sales-person`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create Manager
export const createManager = createAsyncThunk(
  "createManager",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`manager`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete Remark
export const DeleteRemark = createAsyncThunk(
  "DeleteRemark",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`company-remark/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete Remark
export const DeleteSales = createAsyncThunk(
  "DeleteSales",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`company-sales-person/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Create staff
export const createStaff = createAsyncThunk(
  "createStaff",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`company-staff-person`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// companiesStaff
export const companiesStaff = createAsyncThunk(
  "companiesStaff",
  async (
    {
      roles,
      types,
      outlet,
      search,
      pageLimit,
      pageCount,
      company_id,
      sort_by,
      sort_direction,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `company-staff?roles=${roles}&sort_by=${sort_by}&sort_direction=${sort_direction}&types=${types}&outlet=${outlet}&search=${search}&page=${pageCount}&limit=${pageLimit}&company_id=${company_id}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// equipment Transfer
export const equipmentTransfer = createAsyncThunk(
  "equipmentTransfer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`company-transfer-equipment`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// staff Transfer
export const staffTransfer = createAsyncThunk(
  "staffTransfer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`company-transfer-staff`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete Transfer
export const DeleteTransfer = createAsyncThunk(
  "DeleteTransfer",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`company-equipment/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete Outlet
export const DeleteOutlet = createAsyncThunk(
  "DeleteOutlet",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`outlets/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// Delete Staff
export const DeleteStaff = createAsyncThunk(
  "DeleteStaff",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`company-staff/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
// update Staff
export const updateStaff = createAsyncThunk(
  "updateStaff",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`company-staff/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// update Outlets Status
export const updateOutletsStatus = createAsyncThunk(
  "updateOutletsStatus",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.put(`outlets/${id}`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const getDocumnetList = createAsyncThunk(
  "getDocumnetList",
  async (
    {
      pageLimit,
      search,
      type,
      date_range,
      company_id,
      pageCount,
      sort_by,
      sort_direction,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await AxiosApi.get(
        `company-documents?limit=${pageLimit}&search=${search}&type=${type}&date_range=${date_range}&company_id=${company_id}&pageCount=${pageCount}&sort_by=${sort_by}&sort_direction=${sort_direction}`
      );
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Delete equipment
export const DeleteEquipment = createAsyncThunk(
  "DeleteEquipment",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.delete(`company-equipment/${id}`);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// get by id Outlet
export const getByIdOutlet = createAsyncThunk(
  "getByIdOutlet",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.get(`outlets/${id}`);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

// Create Outlet staff
export const createOutletStaff = createAsyncThunk(
  "createOutletStaff",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosApi.post(`staff`, data);
      toast.success(response.data.message);
      return response.data;
    } catch (error) {
      if (!error) {
        throw error.response;
      }
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

const companiesSlice = createSlice({
  name: "companies",
  initialState: initialStates,
  extraReducers: (builder) => {
    builder
      // companies
      .addCase(companiesList.pending, (state) => {
        state.loading = true;
      })
      .addCase(companiesList.fulfilled, (state, action) => {
        state.loading = false;
        state.companiesListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(companiesList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // get companies
      .addCase(getCompanies.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.getCompaniesStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getCompanies.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // getOutlet
      .addCase(getOutlet.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOutlet.fulfilled, (state, action) => {
        state.loading = false;
        state.getOutletStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getOutlet.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // getEquipment
      .addCase(getEquipment.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEquipment.fulfilled, (state, action) => {
        state.loading = false;
        state.getEquipmentStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getEquipment.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // getAllTechnicianList
      .addCase(getAllTechnicianList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllTechnicianList.fulfilled, (state, action) => {
        state.loading = false;
        state.getAllTechnicianListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getAllTechnicianList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // getSalesPersonList
      .addCase(getSalesPersonList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSalesPersonList.fulfilled, (state, action) => {
        state.loading = false;
        state.getSalesPersonListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getSalesPersonList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // getDocumnetList
      .addCase(getDocumnetList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDocumnetList.fulfilled, (state, action) => {
        state.loading = false;
        state.getDocumnetListStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getDocumnetList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // companies
      .addCase(companiesStaff.pending, (state) => {
        state.loading = true;
      })
      .addCase(companiesStaff.fulfilled, (state, action) => {
        state.loading = false;
        state.companiesStaffStatus.data = action.payload;
        state.error = false;
      })
      .addCase(companiesStaff.rejected, (state) => {
        state.loading = false;
        state.error = true;
      })
      // getByIDOutlet
      .addCase(getByIdOutlet.pending, (state) => {
        state.loading = true;
      })
      .addCase(getByIdOutlet.fulfilled, (state, action) => {
        state.loading = false;
        state.getByIdOutletStatus.data = action.payload;
        state.error = false;
      })
      .addCase(getByIdOutlet.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});
const { reducer } = companiesSlice;
export default reducer;
